import { Component, input, InputSignal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';

@Component({
  selector: 'app-content-global-stats-item',
  imports: [IconComponent],
  templateUrl: './content-global-stats-item.html',
  styleUrl: './content-global-stats-item.scss',
})
export class ContentGlobalStatsItem {
  icon: InputSignal<IconType> = input.required();
  label: InputSignal<string> = input.required();
  value: InputSignal<number | undefined> = input();
  perfPercentage: InputSignal<number | undefined> = input();
}
